import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "@/assets/style.css";
import "@/assets/styles/typography.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-toastification/dist/index.css";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import SingleSelect from "./views/utils/SingleSelect.vue";
import TextField from "@/views/utils/TextField.vue";
import DateField from "@/views/utils/DateField.vue";
import PrimaryButton from "@/views/utils/PrimaryButton.vue";
import OutlineButton from "@/views/utils/OutlineButton.vue";
import IconButton from "@/views/utils/IconButton.vue";
import FileInput from "@/views/utils/FileInput.vue";
import FormTags from "@/views/utils/FormTags.vue";
import QuillEditor from "@/views/utils/CustomQuillEditor.vue";
import TextArea from "@/views/utils/TextArea.vue";
import SearchBar from "./views/utils/SearchBar.vue";
import MultiSelectSearch from "./views/utils/MultiSelectSearch.vue";
import ReplaceFile from "./views/utils/ReplaceFile.vue";
import AddAssets from "./views/course-creation/components/AddAssets.vue";
import VideoPlayer from "./views/utils/Video.vue";
import AudioPlayer from "./views/utils/Audio.vue";

import Toast, { TYPE } from "vue-toastification";
import "vue2-datepicker/index.css";
import Datepicker from "vue2-datepicker";
Vue.use(Datepicker);



const options = {
	toastDefaults: {
		[TYPE.ERROR]: {
			timeout: 5000,
			hideProgressBar: true,
		},
		[TYPE.SUCCESS]: {
			timeout: 5000,
			hideProgressBar: true,
		},
	},
};
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(Toast, options);

Vue.component("datetime", Datetime);
Vue.component("DateField", DateField);
Vue.component("SingleSelect", SingleSelect);
Vue.component("TextField", TextField);
Vue.component("PButton", PrimaryButton);
Vue.component("MultiSelectSearch", MultiSelectSearch);
Vue.component("OButton", OutlineButton);
Vue.component("IButton", IconButton);
Vue.component("FileInput", FileInput);
Vue.component("FormTags", FormTags);
Vue.component("QuillEditor", QuillEditor);
Vue.component("TextArea", TextArea);
Vue.component("SearchBar", SearchBar);
Vue.component("ReplaceFile", ReplaceFile);
Vue.component("AddAssets", AddAssets);
Vue.component("VideoPlayer", VideoPlayer);
Vue.component("AudioPlayer", AudioPlayer);

Vue.filter("cloudlink", (url) => {
	try {
		const urlObject = new URL(url);
		const pathname = urlObject.pathname;
		const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
		const decodedFileName = decodeURIComponent(fileName);
		return decodedFileName;
	} catch (error) {
		return url;
	}
});

// vue cloasable directive
let handleOutsideClick;
Vue.directive("closable", {
	bind(el, binding, vnode) {
		// Here's the click/touchstart handler
		// (it is registered below)
		handleOutsideClick = (e) => {
			e.stopPropagation();
			// Get the handler method name and the exclude array
			// from the object used in v-closable
			const { handler, exclude } = binding.value;
			// This variable indicates if the clicked element is excluded
			let clickedOnExcludedEl = false;
			exclude.forEach((refName) => {
				// We only run this code if we haven't detected
				// any excluded element yet
				if (!clickedOnExcludedEl) {
					let excludedEl = vnode.context.$refs[refName];
					excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;
					// Get the element using the reference name
					// See if this excluded element
					// is the same element the user just clicked on
					if (excludedEl) {
						// See if this excluded element
						// is the same element the user just clicked on
						clickedOnExcludedEl = excludedEl.contains(e.target);
					}
				}
			});
			// We check to see if the clicked element is not
			// the dialog element and not excluded
			if (!el.contains(e.target) && !clickedOnExcludedEl) {
				// If the clicked element is outside the dialog
				// and not the button, then call the outside-click handler
				// from the same component this directive is used in
				vnode.context[handler]();
			}
		};
		// Register click/touchstart event listeners on the whole page
		document.addEventListener("click", handleOutsideClick);
	},
	unbind() {
		// If the element that has v-closable is removed, then
		// unbind click/touchstart listeners from the whole page
		document.removeEventListener("click", handleOutsideClick);
	},
});

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
